import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { SubscriptionSettingsPage } from 'features/subscriptionSettings'
import { canViewConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/general')({
  component: SubscriptionSettingsPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('General Settings'),
      },
    ],
  }),
  beforeLoad: protectWithWorkspacePermissions(canViewConfigurationPermission),
})
